import { createFileRoute } from "@tanstack/react-router";
import { ProjectsOverview } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/projects/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useRouteContext() as RouterAppContext;
	
	return (
		<ProjectsOverview
			workspaceId={workspaceId}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}